import React from 'react';

const Kansas = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Kansas Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          No single required form; various disclosures about property conditions
          required.
        </li>
        <li>Disclosure Statement: Required for sellers.</li>
        <li>Radon Disclosure: Required if known radon issues exist.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Kansas-Property-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Seller Property Condition Disclosure Statement{' '}
          </span>{' '}
          – The seller must disclose extensive information concerning the
          condition of the real estate.
        </li>
      </ol>
    </div>
  );
};

export default Kansas;
